<template>
  <div id="unityDetail" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
    <div v-if="loading" class="loadingAlert">
      <el-alert title="加载中" description="正在加载数据,这可能需要一些时间,请稍后..." type="warning" center show-icon :closable="false">
      </el-alert>
    </div>
    <div class="returnButtonBox" v-if="$root.isMob()" @click="isVr ? $emit('return', 'unityVr') : $emit('return', 'unity')">
      <i class="el-icon-back icon"></i>
    </div>
    <div class="title" v-if="!$root.isMob()">
      <el-button size="small" @click="isVr ? $emit('return', 'unityVr') : $emit('return', 'unity')"><i
          class="el-icon-back"></i>返回</el-button>
      <h2>项目详情</h2>
    </div>
    <div class="top">
      <div class="title" v-if="$root.isMob()">
        <h2>{{ data.name }}</h2><span class="tag" v-if="isVr">VR</span>
      </div>
      <div class="left">
        <div class="videoBox">
          <div class="video" v-if="iframeType == 2" v-loading="iframeLoading">
            <iframe v-if="iframeAddressType == 2" ref="video"
              :src="'https://player.bilibili.com/player.html?cid=' + videoCID + '&amp;aid=' + videoAID + '&amp;page=1&amp;as_wide=1&amp;high_quality=1&amp;danmaku=0'"
              frameborder="no" scrolling="no" allowfullscreen="true"></iframe>
            <iframe v-if="iframeAddressType == 1" ref="videoUrl" :src="iframeVideoUrl" frameborder="no" scrolling="no"
              allowfullscreen="true" allow="autoplay" loop="loop"></iframe>
          </div>
          <div ref="iframeImg" class="video" v-if="iframeType == 1" v-loading="iframeLoading">
            <el-image style="height: 100%;width: 100%;" fit="contain" :src="API + iframeImg"
              :preview-src-list="[API + iframeImg]">
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </div>
        </div>
        <div class="videoList" @mouseenter="scrollImgList(true, 'videoList')">
          <div :class="key == 0 ? 'item active' : 'item'" :ref="'videoList_item_' + item.id" v-for="(item, key) in videos"
            :key="item.id" @click="changeVideo(item, $event.target)">
            <img :src="API + item.cover_img" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title" v-if="!$root.isMob()">
          <h2>{{ data.name }}</h2><span class="tag" v-if="isVr">VR</span>
        </div>
        <div class="describe">
          <strong>简介:</strong>{{ data.describe }}
        </div>
        <div class="detectability">
          <strong>检测能力:</strong>{{ data.detectability }}
        </div>
        <div class="projects">
          <strong>实验目标:</strong>{{ data.pilot_projects }}
        </div>
        <!-- <div class="practice">
            <strong>实训练习次数(全站):</strong><span>{{ data.total_practice_nums }}</span>
          </div> -->
        <div class="examine">
          <strong>实训考核次数(全站):</strong><span>{{ data.total_examine_nums }}</span>
        </div>
        <div class="buttonGroup">
          <el-alert v-if="$root.isMob() && isVr" title="请使用VR端体验" type="warning" :closable="false" effect="dark">
          </el-alert>
          <el-alert v-if="$root.isMob() && !isVr" title="移动端暂不支持开始实验，请使用PC端访问。" type="warning" :closable="false"
            effect="dark">
          </el-alert>
          <el-tooltip placement="bottom" v-if="!$root.isMob() && !isVr">
            <el-button v-if="!data.yn_allow" disabled type="primary">开始实验</el-button>
            <div slot="content">
              您没有该项目的实验权限
            </div>
          </el-tooltip>
          <el-tooltip placement="bottom" v-if="!$root.isMob() && isVr">
            <el-button disabled type="primary">开始实验</el-button>
            <div slot="content">
              请使用VR端体验
            </div>
          </el-tooltip>
          <el-button v-if="data.yn_allow && !$root.isMob() && !isVr" type="primary" @click="startUnity">开始实验</el-button>
          <div class="alert" v-if="!$root.isMob()">
            <div v-if="isVr">该项目为VR项目</div>
            <div v-if="isVr">请使用VR端进行体验</div>
            <div v-if="!isVr">请关闭浏览器的鼠标手势功能</div>
            <div v-if="!isVr">
              或使用以下浏览器
              <a href="https://www.google.cn/chrome/" target="_blank">
                <img src="@/assets/img/logo/chrome.png" />
                Chrome
              </a>
              或
              <a href="https://www.firefox.com.cn/" target="_blank">
                <img src="@/assets/img/logo/firefox.svg" />
                Firefox
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="parms">
        <div class="title">
          <h2>设备参数</h2>
        </div>
        <div class="items">
          <div class="item" v-for="item in data.equipment_params_text" :key="item.param_title">
            <span>{{ item.param_title }}:</span><span>{{ item.param_value }}</span>
          </div>
        </div>
      </div>
      <div class="buttonGroup">
        <div ref="initTypeButton" class="item active" @click="changeType(1, $event.target)">
          项目描述
        </div>
        <div class="item" @click="changeType(2, $event.target)">
          相关文档
        </div>
        <div class="item" @click="changeType(3, $event.target)">
          教学视频
        </div>
      </div>
      <div class="text" v-if="contentType == 1 && data.content != ''" v-html="data.content"></div>
      <div class="text" v-if="contentType == 1 && data.content == ''">
        <div class="empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>

      <div class="text" v-if="contentType == 2">
        <div class="links" v-if="docs.length > 0" ref="links">
          <div :class="key == 0 ? 'link active' : 'link'" v-for="(item, key) in docs" :key="item.id"
            @click="viewDoc(item, $event.target)">
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="pdf" v-if="docs.length > 0">
          <iframe ref="doc" :src="$root.isMob()?'':API+docs[0].url + '#toolbar=0&navpanes=0&scrollbar=0' " frameborder="0" scrolling="no"></iframe>
          <!-- <object :data="API + docs[0].url + '#toolbar=0&navpanes=0'" type="application/pdf" width="100%" height="600px"> -->
          <!-- </object> -->
        </div>
        <div class="empty" v-if="docs.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>

      <div class="text studyBox" v-if="contentType == 3">
        <div class="left" v-if="studyVideos.length > 0">
          <h2>课程列表</h2>
          <div class="links" ref="links">
            <div :class="key == 0 ? 'link active' : 'link'" v-for="(item, key) in studyVideos" :key="item.id"
              @click="viewVideo(item, $event.target)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="right" v-if="studyVideos.length > 0">
          <div class="iframeVideo">
            <iframe v-if="stydyVideoType == 2" ref="studyVideo"
              :src="'https://player.bilibili.com/player.html?cid=' + studyVideoCID + '&amp;aid=' + studyVideoAID + '&amp;page=1&amp;as_wide=1&amp;high_quality=1&amp;danmaku=0'"
              frameborder="no" scrolling="no" allowfullscreen="true"></iframe>

            <video v-if="stydyVideoType == 1" :src="studyFullUrl" controls controlsList="nodownload" autoplay></video>
          </div>
        </div>
        <div class="empty" v-if="studyVideos.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'unityDetail',
  props: {
    id: {
      type: Number,
      default: 0
    },
  },
  watch: {
    "contentType": function (val) {
      if (val == 2 && this.$root.isMob()) {
        this.$nextTick(() => {
          this.fixLinkItem();
        })
      }
    }
  },
  data() {
    return {
      loading: false,
      data: [],
      docs: [],
      videos: [],
      studyVideos: [],
      videoCID: "",
      videoAID: "",
      studyVideoCID: "",
      studyVideoAID: "",
      studyFullUrl: "",
      stydyVideoType: 2,
      iframeImg: "",
      iframeType: 1,
      iframeAddressType: 2,
      iframeVideoUrl: "",
      contentType: 1,
      API: window.config.api,
      iframeLoading: false,
      isVr: false,
    }
  },
  methods: {
    fixLinkItem() {
      let link = this.$refs.links.querySelectorAll('.link');
      link.forEach(element => {
        element.classList.remove('active');
      });
    },
    async getData() {
      this.loading = true;
      let data = await this.$root.getDjData(this.id);
      let docs = await this.$root.getDjDoc(this.id);
      let videos = await this.$root.getDjVideos(this.id);
      let studyVideos = await this.$root.getDjVideos(this.id, 2);

      if (data.data.is_vr == 2) {
        this.isVr = true;
      }

      this.studyVideos = studyVideos.data;

      if (studyVideos.data.length > 0) {
        if (studyVideos.data[0].address_type == 2) {
          this.studyVideoCID = studyVideos.data[0].cid;
          this.studyVideoAID = studyVideos.data[0].aid;
        }
        else {
          this.studyFullUrl = this.API + studyVideos.data[0].video_url;
        }
        this.stydyVideoType = studyVideos.data[0].address_type;
      }

      this.data = data.data;
      this.docs = docs.data;

      if (!videos.data || videos.data.length == 0) {
        this.loading = false;
        return
      }
      this.videos = videos.data;
      if (videos.data.length > 0) {
        if (videos.data[0].show_type == 2) {
          if (videos.data[0].address_type == 2) {
            this.videoCID = videos.data[0].cid;
            this.videoAID = videos.data[0].aid;
          }
          if (videos.data[0].address_type == 1) {
            this.iframeVideoUrl = this.API + videos.data[0].video_url;
          }
          this.iframeAddressType = videos.data[0].address_type;
        }
        if (videos.data[0].show_type == 1) {
          this.iframeImg = videos.data[0].cover_img;
          this.iframeLoading = false;
        }
        this.iframeType = videos.data[0].show_type;
      }

      this.loading = false;
    },
    cleanChangeVideoButtonActive() {
      // 遍历 $refs 对象
      Object.keys(this.$refs).forEach((key) => {
        // 判断 ref 是否以 'videoList_item_' 开头
        if (key.startsWith('videoList_item_')) {
          let element = this.$refs[key];
          // 检查 element 是否存在并移除 active 类
          if (element[0] && element[0].classList) {
            element[0].classList.remove('active');
          }
        }
      });
    },
    setChangeVideoButtonActive(targetIndex = 0) {
      this.cleanChangeVideoButtonActive();
      // 遍历 $refs 对象
      let i = 0;
      Object.keys(this.$refs).forEach((key) => {
        if (key.startsWith('videoList_item_') && i == targetIndex) {
          let element = this.$refs[key];
          if (element[0] && element[0].classList) {
            element[0].classList.add('active');
          }
          i++;
        }
      });
    },
    changeVideo(item, target) {
      this.cleanChangeVideoButtonActive();
      target.parentNode.classList.add('active');

      this.iframeLoading = true;
      this.iframeType = item.show_type;
      this.iframeAddressType = item.address_type;

      if (this.iframeType == 1) {
        this.videoCID = "";
        this.videoAID = "";
        this.iframeVideoUrl = "";
        if (item.cover_img == this.iframeImg) {
          this.iframeLoading = false;
          return;
        }
        this.iframeImg = item.cover_img;
        this.iframeLoading = false;
        return;
      }

      if (this.iframeType == 2) {
        this.iframeImg = "";
        if (item.address_type == 2) {
          if (this.videoCID == item.cid && this.videoAID == item.aid) {
            this.iframeLoading = false;
            return;
          }
          this.videoCID = item.cid;
          this.videoAID = item.aid;
          //检查iframe是否加载完毕
          this.$nextTick(() => {
            let iframe = this.$refs.video;
            iframe.onload = () => {
              this.iframeLoading = false;
            }
          })
        }
        if (item.address_type == 1) {
          if (this.iframeVideoUrl == this.API + item.video_url) {
            this.iframeLoading = false;
            return;
          }
          this.iframeVideoUrl = this.API + item.video_url;
          //检查iframe是否加载完毕
          this.$nextTick(() => {
            let iframeVideoUrl = this.$refs.videoUrl;
            iframeVideoUrl.onload = () => {
              this.iframeLoading = false;
            }
          })
        }
      }
    },
    changeType(type, target) {
      this.contentType = type;
      target.parentNode.querySelectorAll('.item').forEach(item => {
        item.classList.remove('active');
      })
      target.classList.add('active');
    },
    // 切换滚动方向
    scrollImgList(status, className) {
      const container = document.getElementsByClassName(className);
      if (status) {
        for (let i = 0; i < container.length; i++) {
          container[i].addEventListener('wheel', this.handleWheelHorizontal);
        }
      } else {
        for (let i = 0; i < container.length; i++) {
          container[i].removeEventListener('wheel', this.handleWheelHorizontal);
        }
      }
    },
    // 横向滚动处理
    handleWheelHorizontal(e) {
      // 阻止默认的纵向滚动行为
      e.preventDefault();
      e.stopPropagation();

      // 根据滚轮的 delta 值来调整横向滚动
      const container = e.currentTarget;
      container.scrollLeft += e.deltaY / 2;
    },
    viewDoc(item, target) {
      let links = this.$refs.links.querySelectorAll('.link');
      links.forEach(element => {
        element.classList.remove('active');
      });

      if (target.classList.contains('link')) {
        target.classList.add('active');
      }
      else {
        target.parentNode.classList.add('active');
      }
      this.$refs.doc.src = this.API + item.url + '#toolbar=0&navpanes=0&scrollbar=0';
    },
    viewVideo(item, target) {
      ''
      let links = this.$refs.links.querySelectorAll('.link');
      links.forEach(element => {
        element.classList.remove('active');
      });

      if (target.classList.contains('link')) {
        target.classList.add('active');
      }
      else {
        target.parentNode.classList.add('active');
      }

      this.stydyVideoType = item.address_type;
      if (item.video_url) {
        this.studyFullUrl = this.API + item.video_url;
      }
      this.studyVideoCID = item.cid;
      this.studyVideoAID = item.aid;
    },
    startUnity() {
      window.open("/unity/" + this.id + "/index.html");
    },
    handleVisibilityChange() {
      //const iframe = this.$refs.videoUrl;
      if (document.visibilityState === "hidden") {
        this.videoCID = "";
        this.videoAID = "";
        this.studyVideos = [];
        this.videoCID = "";
        this.videoAID = "";
        this.studyVideoCID = "";
        this.studyVideoAID = "";
        //this.studyFullUrl="";
        this.iframeVideoUrl = "";
        this.changeType(1, this.$refs.initTypeButton);
        this.setChangeVideoButtonActive(0);
      } else if (document.visibilityState === "visible") {
        this.getData();
      }
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    //页面可见性监听
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    //检查iframe是否加载完毕
    if (this.$refs.video) {
      this.iframeLoading = true;
      let iframe = this.$refs.video;
      if (this.iframeType == 2) {
        iframe.onload = () => {
          this.iframeLoading = false;
        }
      }
      if (this.iframeType == 1) {
        this.iframeLoading = false;
      }
    }
  },
  beforeDestroy() {
    // 移除监听器
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/unityDetail.scss"></style>